import React from "react";
import { Dropdown, Col } from "react-bootstrap";

export default function SelectCourier(props) {
  return (
    <Dropdown className="" drop="down">
      <Dropdown.Toggle variant="secondary" id="dropdown-basic" className="text-sm border col-12 py-0 px-4">
        Pilih Kurir
      </Dropdown.Toggle>

      <Dropdown.Menu className="d-flex flex-wrap" style={{ width: "250px" }}>
        {props.courierList.map((courier, idx) => (
          <Dropdown.Item
            key={idx}
            className="w-auto"
            onClick={async () => {
              props.setLoading(true);
              const isFailed = await props.onClickCourier(courier.courierCode, props.resultIndex);
              props.setLoading(false);
              if (isFailed)
                alert(
                  "Mohon Maaf, resi yang Anda cari masih tidak ditemukan. Pastikan nomor resi dan kurir sudah sesuai"
                );
            }}
          >
            {courier.courierName}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
